import { Outlet } from 'react-router';

export const FullScreenLayout = () => {
  return <Outlet />;
};
